import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.099 2.099A6.1 6.1 0 0 1 4.314.656c.793-.31 1.702-.524 3.039-.58C8.683.016 9.11 0 12.505 0s3.821.015 5.152.076c1.332.061 2.241.27 3.034.58a6.1 6.1 0 0 1 2.216 1.443 6.2 6.2 0 0 1 1.438 2.21c.304.794.518 1.703.579 3.035S25 9.102 25 12.498s-.015 3.821-.076 5.153-.27 2.241-.58 3.034a6.1 6.1 0 0 1-1.443 2.216 6.1 6.1 0 0 1-2.215 1.443c-.793.305-1.702.519-3.034.58-1.33.06-1.758.076-5.152.076s-3.821-.015-5.152-.076c-1.332-.061-2.241-.27-3.034-.58a6.1 6.1 0 0 1-2.215-1.443 6.1 6.1 0 0 1-1.444-2.216c-.304-.793-.518-1.702-.579-3.034S0 15.893 0 12.498c0-3.396.015-3.822.076-5.154s.27-2.241.58-3.034a6.1 6.1 0 0 1 1.443-2.211m17.774.657c-.442-.173-1.103-.376-2.322-.432-1.316-.061-1.712-.071-5.05-.071-3.34 0-3.736.01-5.052.07-1.22.057-1.88.26-2.322.433a3.9 3.9 0 0 0-1.438.935 3.9 3.9 0 0 0-.935 1.438c-.173.442-.376 1.103-.432 2.323-.056 1.316-.07 1.712-.07 5.052s.01 3.735.07 5.051c.056 1.22.26 1.88.432 2.323a3.9 3.9 0 0 0 .935 1.438c.437.437.854.707 1.438.936.442.172 1.103.376 2.322.431 1.316.056 1.713.072 5.051.072s3.735-.01 5.05-.072c1.22-.055 1.881-.259 2.323-.431a3.9 3.9 0 0 0 1.438-.936 3.9 3.9 0 0 0 .935-1.438c.173-.442.376-1.103.432-2.323.056-1.316.071-1.712.071-5.051s-.01-3.736-.071-5.052c-.056-1.22-.26-1.88-.432-2.323a3.9 3.9 0 0 0-.935-1.438 3.9 3.9 0 0 0-1.438-.935",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.5 18.922a6.42 6.42 0 0 1-6.418-6.419 6.419 6.419 0 1 1 6.418 6.419m0-2.252a4.166 4.166 0 0 0 4.166-4.168 4.166 4.166 0 1 0-8.333 0A4.166 4.166 0 0 0 12.5 16.67",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20.676 5.828a1.499 1.499 0 1 1-2.998 0 1.499 1.499 0 0 1 2.998 0"
    }, null, -1)
  ]))]))
}
export default { render: render }